import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import service from "../../baseHttpService";
import {
  PrepareDocumentInputData,
  PrepareDocumentPublicLinkInputData,
  PrepareUpdateDetailDocumentInputData,
} from "../documentFacade";

class PP30Service {
  DoGetPP30DocumentPublicLink(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/PP30/GetPP30DocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetPP30Document(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/PP30/GetPP30Document", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdatePP30DetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/PP30/UpdatePP30DetailDocument", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new PP30Service();
